// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"44":"9d5865f9","197":"bc587b53","387":"f82f974a","403":"7093f6cb","567":"e156c558","616":"d86107a8","706":"f0130ce3"}[chunkId] + ".chunk.js";
};